import { MemberSettingNameMode, UpdatePersonalInfoRequest } from "kz-ui-sdk";

export const buildPersonalInfoRequest = (
  v: {
    firstName: string;
    lastName: string;
    accountName: string;
  },
  nameMode?: MemberSettingNameMode | null,
): UpdatePersonalInfoRequest => {
  switch (nameMode) {
    case MemberSettingNameMode.FirstLast:
      return {
        firstname: v.firstName?.trim(),
        lastname: v.lastName?.trim(),
      };
    case MemberSettingNameMode.FullInFirst:
      return {
        firstname: v.accountName?.trim(),
      };
    default:
      return {
        firstname: v.firstName?.trim(),
        lastname: v.lastName?.trim(),
      };
  }
};
